import { SearchSummaryProps } from './index'
import { skComponent, TextLineSkeleton, TitleSkeleton } from 'components/patterns/Skeleton'
import { BackgroundIcon, OfferCountBadge, PurposeIcon } from './SearchSummary.style'
import { TriviaItem } from './Trivia'
import { ExecutedSearchTheme, UnexecutedSearchTheme } from 'experiences/search/widgets/SearchSummary/theme'
import { ThemedIcon } from 'components/patterns/themes/components/ThemedIcon'
import { DomainTheme } from 'components/patterns/themes/context/ThemeProvider'
import { MoneyBag } from 'components/patterns/icons'
import { Pending } from 'components/patterns/suspense/internals/types'
import { LinkButton } from 'ui/inputs/Button'

export interface PreviousSearchBlocks {
	icon: JSX.Element
	backgroundIcon?: JSX.Element
	loanPurpose: JSX.Element
	productType: JSX.Element
	trivia: JSX.Element[]
	button: JSX.Element
	badge?: JSX.Element
	theme?: DomainTheme
}

export const buildSearchBlocks = (searchDetails: Pending<SearchSummaryProps>): PreviousSearchBlocks => {
	if (searchDetails.pending) {
		return {
			icon: skComponent(PurposeIcon, { height: '48px' }),
			loanPurpose: <TitleSkeleton size="large" />,
			productType: <TextLineSkeleton />,
			trivia: [1, 2, 3].map(i => <TriviaItem pending={true} key={i} />),
			button: <div>{skComponent(LinkButton)}</div>,
			theme: { card: { background: { type: 'color', value: '#fff' } } }
		}
	}

	const { search } = searchDetails
	const { executed, summary } = search
	const triviaItems = summary?.trivia?.map(trivia => <TriviaItem key={trivia.key} trivia={trivia} />) || []
	let buttonText = 'See Your Offers'
	let buttonHref = '/explore/loans'
	let theme = ExecutedSearchTheme

	if (!executed) {
		buttonText = 'Finish Search'
		buttonHref = '/explore/loans'
		theme = UnexecutedSearchTheme
	}

	return {
		icon: <ThemedIcon Icon={MoneyBag} />,
		loanPurpose: <span>{summary?.intent}</span>,
		productType: <span>{summary?.products && summary.products[0]}</span>,
		trivia: [...triviaItems],
		button: <LinkButton href={buttonHref}>{buttonText}</LinkButton>,
		badge: summary?.offerCount ? <OfferCountBadge>{summary.offerCount}</OfferCountBadge> : undefined,
		backgroundIcon: (
			<BackgroundIcon>
				<ThemedIcon Icon={MoneyBag} />,
			</BackgroundIcon>
		),
		theme
	}
}
